export function getEnvironment() {
  const parts = window?.location.hostname.split('.');
  if (parts.length === 2) {
    return 'production';
  }
  return parts[0];
}

export const isProduction = getEnvironment() === 'production';
